<template>
  <!-- Views/Tabs container -->

  <f7-page no-toolbar @page:beforein="onPageBeforeIn" no-swipeback name="online-cs" class="online-cs-info">
    <!-- 在线客服popup -->
    <f7-popup v-show="showOnlineCustomPopup" class="onlineCustom-popup" :opened="onlinePopupOpened" @popup:open="openOnlineCustomPopup" @popup:close="closeOnlineCustomPopup">
      <f7-page>
        <f7-navbar :title="$t('login_0012')">
          <f7-nav-right>
            <f7-link popup-close ><i class="f7-icons">multiply_circle</i></f7-link>
          </f7-nav-right>
        </f7-navbar>
        <iframe :src="onlineCustomUrl" class="iframe-onlineCustom" frameborder="0"></iframe>
      </f7-page>
    </f7-popup>
    <f7-navbar :no-hariline="true" innerClass="inner-bankInfo">
      <f7-nav-left>
        <f7-link @click="$f7router.back()">
          <i class="f7-icons">chevron_left</i>
        </f7-link>
      </f7-nav-left>
      <f7-nav-title>{{ $t("login_0012") }}</f7-nav-title>
    </f7-navbar>
    <template>
      <!-- <div class="qaimg">
        <ul>
          <li>
            <img class="button-single" src="../../../static/images/yt999/qa.png" />
          </li>
        </ul>
        <div class="list inset button-save">
          <ul>
            <li>
              <a href="#" class="list-button button-single" @click="openServiceAction()" click="QASubmit">
                <span class="material-icons" style="color: white; vertical-align: sub">headset_mic</span>
                <span style="display: inline-block">{{ $t("login_0012") }}</span>
              </a>
            </li>
          </ul>
        </div>
      </div> -->
      <div style="padding: 10px;">
        <div class="bg">
          <div>{{ $t("vip_manager_0002",[userInfo.VipLevelName]) }}</div>
          <div>{{ $t("vip_manager_0004") }}</div>
        </div>
        <f7-tab id="tab-accountCenter" class="page-content-cs" tab-active>
          <f7-block>
            <f7-list>
              <f7-list-item v-for="item in onlinecsList" :key="item.CSID" src="" @click="goCSPage(item.Link)" class="icon-animation">
                <span class="title">{{ item.Title }}</span>
                <img class="img-ico" :src="'../../../static/images/yt999/cs_ico/' + item.CSType + '.png'" />
                <i class="f7-icons go-ico">chevron_right</i>
              </f7-list-item>
            </f7-list>
          </f7-block>
        </f7-tab>
        <p style="color: var(--f7-THEME-color);font-size: 15px;font-weight: bold;">{{ $t("common_0004") }}</p>
        <p style="text-indent:2em;">{{ $t("vip_manager_0005") }}</p>
      </div>
    </template>
  </f7-page>
</template>
<script>
import { depositqalist, getInfo, getonlinecslist } from "../../../axios/api";
import { mapGetters } from "vuex";
import moment from "moment";
import { getStore } from "../../../config/utils";
let self;
export default {
  components: {},
  props: {},
  data() {
    return {
      intervalId: null,
      utcMinusFourTime: "",
      depositqaList: [],
      onlinecsList: [],
      memberBankCardList: [],
      onlinePopupOpened: false,
      onlineCustomUrl: "",
      SureNameFlag: false,
      baseInfo: {},
      showOnlineCustomPopup: true,
    };
  },
  watch: {},
  computed: {
    ...mapGetters(["getMerchantInfo", "onlineCustomLoaded","userInfo"]),
  },
  methods: {
    updateTime() {
      const date = new Date();
      const utcTime = date.getTime() + date.getTimezoneOffset() * 60000;
      const tz = parseInt(getStore("TimeZone") || this.$Common_TimeZone_Default, 10);
      const offset = tz * 60;
      const utcLocalDate = new Date(utcTime + offset * 60000);
      this.utcMinusFourTime = utcLocalDate;
    },
    onError(e) {
      console.log(e);
    },
    goCSPage(url) {
      if (url == "") {
        return;
      }
      window.open(url, "_blank");
    },
    getMerchantInfoDetail() {
      const self = this;
      getInfo().then((data) => {
        if (data.Code === "NoError" && data.Data) {
          self.baseInfo = data.Data.BaseInfo;
        }
      });
    },
    getDepositQAListEvent() {
      const self = this;
      depositqalist().then((data) => {
        if (data.Code === "NoError") {
          self.depositqaList = data.Data;
        }
      });
    },
    getCSList() {
      const self = this;
      getonlinecslist().then((data) => {
        if (data.Code === "NoError") {
          self.onlinecsList = data.Data;
        }
      });
    },
    openServiceAction() {
      const self = this;
      const baseInfo = self.baseInfo;
      if (baseInfo.CSType == 2) {
        if (!this.onlineCustomLoaded) {
          let loading = self.$f7.dialog
            .create({
              title: "",
              text: "Loading...",
              cssClass: "dialog-preloadgame",
            })
            .open();
          setTimeout(() => {
            loading.close();
            this.openServiceAction();
          }, 1500);
        } else {
          window.Tawk_API.toggle();
        }
      } else {
        self.onlineCustomUrl = baseInfo.MobileService;
        self.onlinePopupOpened = true;
      }
    },
    onlineCustomService() {
      const self = this;
      self.$f7.actions.close(".actions-qq");
      self.$f7.actions.close(".actions-wechat");
      self.onlinePopupOpened = true;
    },
    back() {
      this.$f7router.back();
    },
    onPageBeforeIn() {
      const self = this;
      self.$nextTick(() => {
        self.$f7.emit("myCustomEvent", "online-cs");
      });
    },
    openOnlineCustomPopup() {
      this.showOnlineCustomPopup = true;
    },
    closeOnlineCustomPopup() {
      this.onlinePopupOpened = false;
      this.showOnlineCustomPopup = false;
    },
  },
  created() {
    self = this;
    self.getMerchantInfoDetail();
    self.getDepositQAListEvent();
    self.getCSList();
  },
  mounted() {
    this.updateTime(); // Call updateTime() when the component is mounted
    this.intervalId = setInterval(this.updateTime, 1000); // Update time every second
  },
  beforeDestroy() {
    clearInterval(this.intervalId);
  },
  updated() {},
};
</script>
<style lang="less" scoped>
.iframe-onlineCustom {
  width: 100%;
  height: calc(100% - 0px);
  min-height: calc(100% - 0px);
}
.online-cs-info {
  --f7-page-toolbar-bottom-offset: 0;
  .qaimg {
    width: 95%;
    margin: auto;
    border-radius: 5px;
    text-align: center;
    margin-top: 10px;
    img {
      border-radius: 5px;
      max-width: 100%;
      max-height: 100%;
      width: 100px;
      height: auto;
      min-width: 100%;
      min-height: 100%;
    }
  }

  .accordion-list {
    //background-color: #EEEEEE;
    margin-top: 20px;
    border-radius: 5px;
    width: 100%;
    //margin: auto;
    .accordion-item {
      border-bottom: 1px solid #f0f0f0;
      .col-title {
        position: relative;
        .help {
          position: absolute;
          left: 0px;
          border-radius: 5px;
          width: 19px;
          height: auto;
          vertical-align: middle;
        }
        .s-title {
          width: 94%;
          margin-left: 15px;
          margin-top: -1px;
          font-size: 15px;
          color: #464646;
          text-decoration: underline;
          word-break: break-all;
          word-wrap: break-word;
        }
        .accordion-item-content {
          .ans {
            width: 100%;
            margin-left: 10px 10px 10px 10px;
            // word-break: break-all;
            // word-wrap: break-word;
          }
        }
      }
    }
  }
  .curr-time {
    text-align: center;
    margin-top: 5px;
    font-size: 15px;
    color: #1168b5;
  }
  .button-save {
    margin: 10px 0px;

    ul {
      background: #3e66ce;
      li {
        a {
          color: #fff;
        }
      }
    }
  }
}
.page-content-cs {
  .item-content {
    position: relative;
    .img-ico {
      position: absolute;
      left: -15px;
      height: 32px;
    }
    .go-ico {
      font-size: 18px;
      color: #d1d1d1;
    }
    .title {
      padding-left: 26px;
    }
  }
}

.bg {
  width: 100%;
  height: 160px;
  background-image: url('../../../static/images/yt999/home/ico/ZZicon/service.png');
  background-size: auto 100%;
  background-repeat: no-repeat;
  color: white;
  div{
    padding-left: 45%;
    
  }
  div:nth-child(1){
    font-size: 18px;
    font-weight: bold;
    padding-top: 27px;
    padding-bottom: 10px;
    span{
      color: var(--f7-THEME-color);
    }
  }
}
.mobile{
  display: flex;
  align-items: flex-end;
  margin-bottom: 10px;
  span{
    border-bottom: 1px solid #ccc;
    width: 90%;
    padding-left: 10px;
  }
}
.block{
  margin:  0;
  padding: 0;
  .list{
    margin: 0;
    font-size: 14px;
  }
}
</style>
